import React, { useState } from 'react';
import styled from 'styled-components';

interface ToggleButtonProps {
  toggle1:string;
  toggle2:string;
  defaultOn?: boolean;
  onToggle?: (isOn: boolean) => void;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ defaultOn = true, onToggle,toggle1,toggle2 }) => {
  const [isOn, setIsOn] = useState(defaultOn);

  const handleToggle = () => {
    const newIsOn = !isOn;
    setIsOn(newIsOn);
    if (onToggle) {
      onToggle(newIsOn);
    }
  };

  return (
    <Style>
      <button
        onClick={() => handleToggle()}
        className={isOn ? 'active' : ''}
        style={{ borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px' }}
      >
        {toggle1}
      </button>
      <button
        onClick={() => handleToggle()}
        className={!isOn ? 'active' : ''}
        style={{ borderTopRightRadius: '4px', borderBottomRightRadius: '4px' }}
      >
        {toggle2}
      </button>
    </Style>
  );
};

export default ToggleButton;

const Style = styled.div`
  button {
    margin-bottom: 12px;
    padding: 10px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    border: none;
    outline: none;
    color: #a6abb2;
    background-color: transparent;
    border: 2px solid #a6abb2;
  }
  .active {
    color: #fff;
    background-color: #000;
    border: 2px solid #000;
  }
`;
